<template>
  <div class="loading-wrapper">
    <div class="animation-holder">
      <div class="animation-headline">Slika se nalaga</div>
      <div class="spinner">
        <div
          class="dot"
          :style="`border-color: ${interfaceColor}`"
        />
        <div
          class="dot"
          :style="`border-color: ${interfaceColor}`"
        />
        <div
          class="dot"
          :style="`border-color: ${interfaceColor}`"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            interfaceColor: '#ff0000'
        }
    }
}
</script>

<style lang="scss" scoped>
.loading-wrapper {
  background-color: rgba(0, 0, 0, 0.8);
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 999;

  .spinner {
    & {
      position: absolute;
      z-index: 1003;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      margin: 0 auto;
      display: block;
      height: 15px;
      width: auto;
      box-sizing: border-box;
      text-align: center;
    }

    &.hide {
      display: none;
    }
  }

  .dot {
    & {
      float: left;
      margin: 0 calc(15px / 2);
      width: 15px;
      height: 15px;
      border: calc(15px / 5) solid rgba(255, 255, 255, 0.8);
      border-radius: 50%;
      transform: scale(0);
      box-sizing: border-box;
      animation: spinner-animation 1000ms ease infinite 0ms;
    }

    &:nth-child(1) {
      animation-delay: calc(300ms * 1);
    }

    &:nth-child(2) {
      animation-delay: calc(300ms * 2);
    }

    &:nth-child(3) {
      animation-delay: calc(300ms * 3);
    }
  }
}
.animation-holder {
  margin-top: 50%;
}

@keyframes spinner-animation {
  50% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>

